import { defaults, defaultStack } from '@pnotify/core';

defaults.delay = 2000;
defaults.sticker = false;
defaults.closerHover = false;
defaults.mode = 'light';
defaultStack.maxOpen = Number.POSITIVE_INFINITY;
defaultStack.modal = false;

globalThis.disablePnotify = function() {
  defaults.autoOpen = false;
};
